module.exports = __webpack_public_path__ + "static/media/GT.6ab376da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GT.svg
// module id = 266
// module chunks = 0